<div class="sample-app content-border-bottom">

  <header nx-header>
    <nx-header-brand class="nx-margin-right-5xl">
      <nx-link>
        <a href="{{'app.home.url' | translate}}">
          <figure nxFigure>
            <img class="logo-img"
                 src="https://s3.eu-central-1.amazonaws.com/al-cdn/dist/images/Allianz_logo.svg"
                 alt="Brand Logo"
                 role="none"
            />
          </figure>

        </a>
      </nx-link>

    </nx-header-brand>

  </header>
  <div nxLayout="grid nogutters" class="t-bg-soft-blue content-border-top">
    <div nxRow class="">

      <div nxCol="12" nxColOffset="0"
           class="  u-text-center ">
        <div nxRow class="">
          <div nxCol="12,12,8" nxColOffset="0,0,2" class=" ">

            <h1 nxHeadline="section"
                class="u-text-center  nx-margin-top-2m nx-margin-bottom-2m ">{{'copy.headline' | translate}}</h1>

          </div>
        </div>
      </div>
    </div>
  </div>

  <router-outlet ></router-outlet>
</div>

<footer nx-footer style="border-top:solid 1px #c4c4c4">
  <nx-footer-copyright>&copy; Allianz {{anio}}</nx-footer-copyright>
  <nx-footer-navigation>
    <nx-footer-link>
      <a target="_blank"
         href="{{'footer.link_1_url'|translate}}">{{'footer.link_1_label'|translate}}</a>
    </nx-footer-link>
    <nx-footer-link>
      <a target="_blank"
         href="{{'footer.link_2_url'|translate}}">{{'footer.link_2_label'|translate}}</a>
    </nx-footer-link>
    <nx-footer-link>
      <a target="_blank"
         href="{{'footer.link_3_url'|translate}}">{{'footer.link_3_label'|translate}}</a>
    </nx-footer-link>
  </nx-footer-navigation>
</footer>
